import { render, staticRenderFns } from "./job.vue?vue&type=template&id=2e4c0600"
import script from "./job.vue?vue&type=script&lang=js"
export * from "./job.vue?vue&type=script&lang=js"
import style0 from "./job.vue?vue&type=style&index=0&id=2e4c0600&prod&lang=scss&scope=true"
import style1 from "./job.vue?vue&type=style&index=1&id=2e4c0600&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports